import React from "react";
import LocalUrlMaker from "../../../lib/LocalUrlMaker";
import {reportStartCheckout} from "../utility/startCheckout";
import {getClassList} from "../../../Utility/siteConfig";
import {BUTTON_LOGOS, SECONDARY_CHECKOUT_BUTTON_CLASSES} from "../../constants";

/**
 * Note we have two similarly named components in different SPA's.
 *
 * This one is on the CART page, and it simply sends the user into
 * checkout with Affirm preselected - it doesn't actually talk to Affirm.
 */
export default function StartAffirmButton(props) {
  const { shoppingCart={}, cartConfig = {}} = props;

  //alert(JSON.stringify(cartConfig, null, 2));

  // if (!affirmAvailableForCart(shoppingCart, cartConfig?.affirm))
  //   return null;

  let checkoutPath = LocalUrlMaker.jsonPath(
    `/new_checkout/${shoppingCart.cartCode}?pt=affirm`);

  const handleClick = (evt) => {
    reportStartCheckout({
      shoppingCart, checkoutType: "affirm"
    });
  };

  const className = getClassList({
    key: 'CheckoutButton.common',
    fallback: SECONDARY_CHECKOUT_BUTTON_CLASSES
  })

  return <a
    className={className} href={checkoutPath} onClick={handleClick}>
        <img className="block mx-auto"
          src={BUTTON_LOGOS.affirm} style={{height:'28px'}}
          alt="Checkout with Affirm"  /></a>
}
